import { render, staticRenderFns } from "./google-get-folder-output.vue?vue&type=template&id=3547cfef&scoped=true"
import script from "./google-get-folder-output.vue?vue&type=script&lang=js"
export * from "./google-get-folder-output.vue?vue&type=script&lang=js"
import style0 from "./google-get-folder-output.vue?vue&type=style&index=0&id=3547cfef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547cfef",
  null
  
)

export default component.exports